import { render, staticRenderFns } from "./Disaster_apply.vue?vue&type=template&id=217c5db8"
import script from "./Disaster_apply.vue?vue&type=script&lang=js"
export * from "./Disaster_apply.vue?vue&type=script&lang=js"
import style0 from "./Disaster_apply.vue?vue&type=style&index=0&id=217c5db8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports